import { graphql } from 'react-relay';

export const UserShortFragment = graphql`
    fragment UserShortFragment on User {
        id
        first_name
        last_name
        email
        phone
    }
`;
